export const TYPE_DATE = 'Date';
export const TYPE_STATUS = 'Status';
